<template>
    <div id="contact" ref="contact" v-scroll="handleScroll">
        <div>
            <span>{{ $t("contact.name") }}</span>
            <a :href="'tel:' + phone">
                <icon icon-name="phone" :icon-alt="phone"><icon-phone/></icon>
            </a>
            <a :href="'mailto:' + email">
                <icon icon-name="email" :icon-alt="email"><icon-email/></icon>
            </a>
            <a :href="whatsapp" target="_blank">
                <icon icon-name="whatsapp"><icon-whatsapp/></icon>
            </a>
        </div>
    </div>
</template>

<script>
    import Icon from "./IconBase";
    import IconPhone from "./icons/phone";
    import IconEmail from "./icons/email";
    import IconWhatsapp from "./icons/whatsapp";

    export default {
        name: "ContactBar",
        data () {
            return {}
        },
        props: {
            phone: {
                type: String,
                default: () => { return ''; }
            },
            email: {
                type: String,
                default: () => { return ''; }
            },
            whatsapp: {
                type: String,
                default: () => { return ''; }
            }
        },
        components: {
            Icon, IconPhone, IconEmail, IconWhatsapp
        },
        methods: {
            displayContactBar : function(){
                this.$refs.contact.setAttribute(
                    'style',
                    'transition: 1s; bottom: 0px'
                )
                this.$refs.contact.classList.remove('active')

            },
            changeContactBar : function(){
                this.$refs.contact.setAttribute(
                    'style',
                    'transition: .5s; background-color: transparent; bottom: 18vh'
                )
                this.$refs.contact.classList.add('active')
            },
            handleScroll: function () {
                this.displayContactBar()

                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

                if(bottomOfWindow) {
                    this.changeContactBar()
                }
            }
        },
        mounted() {
            setTimeout(() => { this.displayContactBar() }, 3000)
        }
    }
</script>

<style lang="sass" scoped>
    #contact
        display: flex
        justify-content: center
        align-items: center
        width: 100%
        height: 10%
        min-height: 64px
        padding: 0 20px
        background-color: $transparent-light

        position: fixed
        bottom: -200px

        div
            width: 300px
            margin: 0 auto
            display: flex
            flex-wrap: nowrap
            justify-content: space-between
            align-items: center

            a
                padding: .2em
                @media (pointer: coarse)
                    padding: .8em

            span, svg path
                transition: .5s
                fill: $dark-grey
                color: $dark-grey

        &:hover, &.active
            span, svg path
                fill: $dark
                color: $dark

    @media screen and (max-width: $mobile-break-point)
        #contact
            span, svg path
                fill: $dark
                color: $dark
</style>